
  var _styles = {
  "search-wrap": {
    "display": "flex",
    "flexDirection": "row",
    "paddingTop": "0.32rem",
    "paddingRight": "0.32rem",
    "paddingBottom": "0.26667rem",
    "paddingLeft": "0.32rem",
    "justifyContent": "space-between",
    "alignItems": "center"
  },
  "ai-switch-wrap": {
    "width": "0.77333rem",
    "height": "0.77333rem",
    "marginRight": "0.10667rem"
  }
};

  if (typeof FontFace === 'function') {
    
    var fontFace0 = new FontFace('meituantype-Bold', 'url("https://s3.meituan.net/static-prod01/com.sankuai.dde.lowcode.docs-files/MeituanType-Bold.ttf") format("truetype")');
    document.fonts.add(fontFace0);
    
    var fontFace1 = new FontFace('MTNewDigitalDisplay-Bold', 'url("https://s3plus.meituan.net/tex-external-advertising/MTNewDigitalDisplay-Bold.otf") format("opentype")');
    document.fonts.add(fontFace1);
    
  }
    


  module.exports = _styles;
  